import AdminMidProspectVaspsTable from './AdminMidProspectVaspsTable'

export default AdminMidProspectVaspsTable
